<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003605.installation.securite.titre' | translate"
      [description]="'P0003605.installation.securite.description' | translate"
    >
    </app-header-configuration>

    <app-switch-configuration
      [title]="'P0003605.parametre.securite' | translate"
      [nameCustom]="'P0003605.parametre.securite.value' | translate"
      [value]="actionStack!.getValue('icIActivationProtectionSurdosage') !== 0"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.InjectionChlore_Installation,
          'icIActivationProtectionSurdosage',
          $event ? 1 : 0,
          null
        )
      "
    >
    </app-switch-configuration>

    @if (this.actionStack!.getValue('icIActivationProtectionSurdosage') === 1) {
      <app-label-configuration
        [titleListe]="'P0003605.parametre.duree' | translate"
        [value]="actionStack!.getValue('icPDureeLimiteSurdosage')"
        [liste]="P0003605DureeLimiteSurdosage"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.InjectionChlore_Parametrage,
            'icPDureeLimiteSurdosage',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    <app-label-description
      [description]="'P0003605.parametre.securite.description' | translate"
    ></app-label-description>

    @if (isSupportTechnique()) {
      <app-switch-configuration
        [title]="'P0003605.parametre.desinfection' | translate"
        [nameCustom]="'P0003605.parametre.desinfection.value' | translate"
        [description]="
          'P0003605.parametre.desinfection.description' | translate
        "
        [value]="
          actionStack!.getValue('icPActivationSecuriteDesinfection') !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.InjectionChlore_Parametrage,
            'icPActivationSecuriteDesinfection',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>
    }

    @if (showPositionModal()) {
      <app-information-title
        [title]="'P0003605.parametre.sourcereference' | translate"
      ></app-information-title>

      <div class="my-3">
        <app-affichage-warning
          icon="fa-regular fa-exclamation-circle"
          [name]="'configuration.presentationmiseenservice.warning' | translate"
        ></app-affichage-warning>
      </div>

      <app-larged-link
        [name]="'P0003605.configuration.sourceDebut' | translate"
        (onPress)="openPositionModal()"
      ></app-larged-link>

      <app-label-description
        [description]="
          'P0003605.parametre.sourcereference.description' | translate
        "
      ></app-label-description>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
